import { apiInstance } from "../apiInstance";
import { protectedResources } from "../../msalAuthConfig";

const headers = {
    'Content-Type': 'application/json',
};

const cohortApi = {
    getCohortData: (id) => {
        return apiInstance({
            method: 'GET',
            url: `${protectedResources.apiCompany.endpoint}/${id}/cohorts`,
            headers,
        })
    },
    getCohortUploadUpdateData: (id) => {
        return apiInstance({
            method: 'GET',
            url: `${protectedResources.apiCompany.endpoint}/${id}/cohorts-with-cohort-update-data`,
            headers,
        })
    },

    getCohortDataByStatus: (id, status) => {
        return apiInstance({
            method: 'GET',
            url: `${protectedResources.apiCompany.endpoint}/${id}/cohorts/${status}`,
            headers,
        })
    },

    getCohortNotifications: (id) => {
        return apiInstance({
            method: 'GET',
            url: `${protectedResources.apiCompany.endpoint}/${id}/notifications`,
            headers,
        })
    },

    archiveCohortNotifications: (idList) => {
        return apiInstance({
            method: 'POST',
            url: `${protectedResources.apiCohortManagement.endpoint}/notifications/archive`,
            headers,
            data: idList,
        })
    },

    getNotificationsByApplication: (id, application) => {
        return apiInstance({
            method: 'GET',
            url: `${protectedResources.apiCompany.endpoint}/${id}/notifications/${application}`,
            headers,
        })
    },

    updateNotificationsStatus: (id, status) => {
        return apiInstance({
            method: 'PUT',
            url: `${protectedResources.apiCompany.endpoint}/${id}/notifications/${status}`,
            headers,
        })
    },

    mergeCohorts: async (cohorts) => {
        return await apiInstance({
            method: 'post',
            url: `${protectedResources.apiCohortManagement.endpoint}/merge`,
            headers,
            data: cohorts,
        })
    },

    getCohortUploadItem: (cohortId) => {
        return apiInstance({
            method: 'GET',
            url: `${protectedResources.apiCohortManagement.endpoint}/${cohortId}/cohortUploadItem`,
            headers,
        })
    },

    getCohortUploadItemByCohortUpdateId: (cohortUpdateId) => {
        return apiInstance({
            method: 'GET',
            url: `${protectedResources.apiCohortManagement.endpoint}/cohortUpdateId/${cohortUpdateId}/cohortUploadItem`,
            headers,
        })
    },

    archiveCohort: (cohortId) => {
        return apiInstance({
            method: 'PUT',
            url: `${protectedResources.apiCohortManagement.endpoint}/${cohortId}/archive`,
            headers,
        })
    },

    scheduleCohort: (cohortId) => {
        return apiInstance({
            method: 'PUT',
            url: `${protectedResources.apiCohortManagement.endpoint}/${cohortId}/schedule`,
            headers,
        })
    },

    getCohortRiskScores: (id) => {
        return apiInstance({
            method: 'GET',
            url: `${protectedResources.apiCohortManagement.endpoint}/${id}/riskScores`,
            headers,
        })
    },

    validateCohortMemberId: async (data) => {
        return await apiInstance({
            method: 'GET',
            url: `${protectedResources.apiCohortManagement.endpoint}/${data.id}/member/${data.memberId}`,
            headers,
        });
    },

    /** Single cohort member read (same route as validateCohortMemberId). */
    getCohortMemberById: async (cohortId, memberId) => {
        return await apiInstance({
            method: 'GET',
            url: `${protectedResources.apiCohortManagement.endpoint}/${cohortId}/member/${memberId}`,
            headers,
        });
    },

    getMemberUpdateResultByCohortUpdateId: async (id) => {
        return apiInstance({
            method: 'GET',
            url: `${protectedResources.apiCohortManagement.endpoint}/cohort-update-input/${id}/member-update-results`,
            headers,
        })
    },

    getRiskExplorerCohortViewData: (id) => {
        return apiInstance({
            method: 'GET',
            url: `${protectedResources.apiCompany.endpoint}/${id}/risk-explorer/cohort-view`,
            headers,
        })
    },
    getCohortDataCount: (id) => {
        return apiInstance({
            method: 'GET',
            url: `${protectedResources.apiCompany.endpoint}/${id}/cohorts-count`,
            headers,
        })
    },
    getCohortDataByPageAndSize: (companyId, page, pageSize) => {
        return apiInstance({
            method: 'GET',
            url: `${protectedResources.apiCompany.endpoint}/${companyId}/cohorts/${page}/${pageSize}`,
            headers,
        })
    },
    getCohortUpdateCountByCohortUpdateId: (cohortUpdateId) => {
        return apiInstance({
            method: 'GET',
            url: `${protectedResources.apiCohortManagement.endpoint}/cohort-update/${cohortUpdateId}/cohort-update-count`,
            headers,
        })
    },
    getApplicationMemberByHealthPlanId: (cohortId, healthPlanMemberId) => {
        return apiInstance({
            method: 'GET',
            url: `${protectedResources.apiCohortManagement.endpoint}/${cohortId}/application-member/healthPlanMemberId/${healthPlanMemberId}`,
            headers,
        })
    },
    getApplicationMemberByName: (cohortId, name) => {
        return apiInstance({
            method: 'GET',
            url: `${protectedResources.apiCohortManagement.endpoint}/${cohortId}/application-member/name/${name}`,
            headers,
        })
    }
};

export default cohortApi;
